(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click',function(event){document.querySelectorAll('.desktop-nav .mv-nav-group[open]').forEach(function(group){if(!group.contains(event.target))group.open=false;});});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.mv-nav-group[open],.mobile-menu[open]').forEach(function(group){group.open=false;});}});

  } catch(e) { console.error(e); }
})();
})();
